var map = {
	"./course_0.gif": 300,
	"./course_1.gif": 5355,
	"./course_2.gif": 8999,
	"./course_3.gif": 8744,
	"./course_4.gif": 1144,
	"./course_5.gif": 9601,
	"./course_6.gif": 7744
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7890;